module.exports = __webpack_public_path__ + "img/PackageUnconditional.50c2d29e.png";